var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    fill: "#203560"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5009 60C97.5009 72.4264 87.4273 82.5 75.0009 82.5C62.5745 82.5 52.5009 72.4264 52.5009 60C52.5009 47.5736 62.5745 37.5 75.0009 37.5C87.4273 37.5 97.5009 47.5736 97.5009 60ZM90.0009 60C90.0009 68.2843 83.2852 75 75.0009 75C66.7166 75 60.0009 68.2843 60.0009 60C60.0009 51.7157 66.7166 45 75.0009 45C83.2852 45 90.0009 51.7157 90.0009 60Z",
    fill: "#ABEBF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0009 93.75C50.722 93.75 30.0357 108.107 22.1558 128.22C24.0754 130.126 26.0975 131.929 28.2132 133.62C34.081 115.154 52.4886 101.25 75.0009 101.25C97.5133 101.25 115.921 115.154 121.789 133.62C123.904 131.929 125.926 130.126 127.846 128.22C119.966 108.107 99.2799 93.75 75.0009 93.75Z",
    fill: "#ABEBF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default_avatar.241b766acb81f0ff7c51360e4110a222.svg";
export { ForwardRef as ReactComponent };